<section class="browse-bar-container">
  <apps-empty-state *ngIf="!barItems?.length && isAppsItemsModel; else main" [view]="'Banner'"></apps-empty-state>
  <ng-template #main>
    <div class="apps-wrapper" *ngIf="barItems?.length">
      <div #appsContainer id="appsContainer" data-cy="search-in-list" class="apps-container transparent">
        <ng-container *ngFor="let item of barItems.slice(0, appsLimit); trackBy: trackItem">
          <ng-container
            *ngTemplateOutlet="
              (item.appId !== 'office365' && item.type === 'service') || item.type === 'type' || item.type == 'account' || !shortView
                ? serviceTmpl
                : item.type === 'app' || (item.appId == 'office365' && item.type == 'service')
                ? appTmpl
                : null;
              context: { item: item, type: item.type, showLinkIndication: isLauncher }
            "
          >
          </ng-container>
        </ng-container>
        <div
          *ngIf="isShowMoreAvailable"
          #moreApps
          class="filter app"
          (click)="onMoreAppsClicked()"
          tooltipPosition="bottom"
          pTooltip="More"
          tooltipStyleClass="u-tooltip"
        >
          <u-icon [model]="{ type: 'font', value: 'icon-chevron-down' }" [styles]="{ fontSize: '12px' }"></u-icon>
        </div>
      </div>
    </div>
  </ng-template>
</section>

<ng-template #appTmpl let-item="item">
  <div class="app-wrap" [class.syncing-animation]="item.syncStatus === 'Started'" tabindex="-1" id="{{ item.name }}">
    <div
      [class.disabled]="isDisabled(item)"
      [pTooltip]="itemsState[item.appId].tooltip"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      tabindex="0"
      [style.display]="item.type === 'service' && !item.links ? 'none' : 'flex'"
      [attr.name]="item.name"
      class="app filter"
      (click)="navigateTo(item)"
      #optionElement
      [attr.data-id]="item.name + ':' + item.type"
      (mouseover)="onMouseover(optionElement)"
      (mouseout)="onMouseOut()"
    >
      <entity-icon [model]="item.icon" [size]="'16px'" class="bar-icon" [class.blink]="item.syncStatus === 'Started'"></entity-icon>
    </div>
    <indicator [size]="'5px'" class="stale-indicator" *ngIf="itemsState[item.appId].hasRedDot" [intent]="'danger'"></indicator>
  </div>
</ng-template>

<ng-template #serviceTmpl let-item="item" let-type="type" let-showLinkIndication="showLinkIndication">
  <ng-container *ngIf="item | barItemToSuggestionTag: type as serviceItem">
    <div
      class="app-wrap"
      [class.syncing-animation]="item.syncStatus === 'Started'"
      [class.hide]="item['isHidden']"
      tabindex="-1"
      [ngClass]="{ 'big-suggestion': !isLauncher }"
      id="{{ item.name }}"
    >
      <suggestion-tag
        [model]="serviceItem"
        [clickable]="true"
        [removable]="false"
        [disabled]="serviceItem.disabled"
        [lightOverlay]="true"
        (click)="navigateTo(item, type)"
        #optionElement
        *ngIf="!item.hidden"
        tabindex="0"
        [attr.data-id]="item.name + ':' + item.type"
        class="filter tag"
        [class.disabled]="serviceItem.disabled"
        [pTooltip]="showLinkIndication && itemsState[item.appId].tooltip"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      ></suggestion-tag>
      <indicator
        [size]="'5px'"
        class="stale-indicator in-suggestion-tag"
        *ngIf="itemsState[item.appId]?.hasRedDot"
        [intent]="'danger'"
      ></indicator>
    </div>
  </ng-container>
</ng-template>
